import React, { useEffect, useState } from "react";
import { AmountFormat } from "components/common/formatter";
import { getMattersBalances } from "services/postingsService";
import styles from "./MatterBalancesCard.module.scss";

const EMPTY_BALANCES = {};

const CHIPS = [
  { key: "officeBalance", label: "Office Bal", tone: "indigo" },
  { key: "unpaidBills", label: "Unpaid Bills", tone: "pink" },
  { key: "clientBalance", label: "Client Bal", tone: "green" },
  { key: "ddaBalance", label: "DDA", tone: "red" },
  { key: "duuBalance", label: "DUU", tone: "amber" },
  { key: "dpuBalance", label: "DPU", tone: "slate" },
  { key: "dubBalance", label: "DUB", tone: "blue" },
  { key: "wipBalance", label: "WIP", tone: "rose" },
  { key: "undertakingBalance", label: "Undertaking", tone: "purple" },
];

const displayValue = (value) => {
  const formatted = AmountFormat(value);
  return formatted === "" ? "—" : formatted;
};

const MatterBalancesCard = ({ matterId, className = "" }) => {
  const [balances, setBalances] = useState(EMPTY_BALANCES);

  useEffect(() => {
    if (!matterId) {
      setBalances(EMPTY_BALANCES);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await getMattersBalances(matterId);
        if (!cancelled) setBalances(res?.matterBalances ?? EMPTY_BALANCES);
      } catch (err) {
        console.error("Failed to fetch matter balances", err);
        if (!cancelled) setBalances(EMPTY_BALANCES);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [matterId]);

  return (
    <div className={`${styles.card} ${className}`}>
      {CHIPS.map((chip) => (
        <div
          key={chip.key}
          className={`${styles.tile} ${styles[chip.tone]}`}>
          <span className={styles.label}>{chip.label}:</span>
          <span className={styles.value}>
            {displayValue(balances?.[chip.key])}
          </span>
        </div>
      ))}
    </div>
  );
};

export default MatterBalancesCard;
